import { useTranslation } from '@gimlite/common';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Icon } from '../icon/icon.component';
import './searchbar.component.scss';

export declare namespace SearchbarType {
  type Props = {
    className?: string | null;
    disabled?: boolean;
    defaultValue?: string | null;
    onSearch?: (value: string) => void;
  };
}

const DEBOUNCE_MS = 300;

export const Searchbar = observer(
  ({ className, disabled, onSearch, defaultValue }: SearchbarType.Props) => {
    const { t } = useTranslation();
    const [searchValue, setSearchValue] = useState<string | null>(
      defaultValue || null,
    );

    useEffect(() => {
      if (searchValue === null) return;

      const timeoutId = setTimeout(() => {
        onSearch?.(searchValue);
      }, DEBOUNCE_MS);

      return () => clearTimeout(timeoutId);
    }, [searchValue, onSearch]);

    return (
      <div
        className={classNames(
          'searchbar',
          {
            'searchbar--disabled': disabled,
          },
          className,
        )}
      >
        <Icon color="deep_indigo_50" variant="search" />
        <input
          value={searchValue || ''}
          onChange={(e) => setSearchValue(e.target.value)}
          className={classNames('searchbar__input')}
          placeholder={t('watermelon-search')}
        />
      </div>
    );
  },
);
